export default __webpack_public_path__ + "static/media/logomca.d9486202.png";